var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4502_27351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5H2.5C1.11917 5 0 6.11917 0 7.5V13.3333C0 14.7142 1.11917 15.8333 2.5 15.8333H17.5C18.8808 15.8333 20 14.7142 20 13.3333V7.5C20 6.11917 18.8808 5 17.5 5Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10V9.16671C11.6667 8.70671 11.2933 8.33337 10.8333 8.33337H9.16667C8.70667 8.33337 8.33333 8.70671 8.33333 9.16671V10C7.87333 10 7.5 10.3734 7.5 10.8334V11.6667C7.5 12.1267 7.87333 12.5 8.33333 12.5H11.6667C12.1267 12.5 12.5 12.1267 12.5 11.6667V10.8334C12.5 10.3734 12.1267 10 11.6667 10Z",
    fill: "url(#paint0_linear_4502_27351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83332 10V9.16671C5.83332 8.70671 5.45999 8.33337 4.99999 8.33337H3.33332C2.87332 8.33337 2.49999 8.70671 2.49999 9.16671V10C2.03999 10 1.66666 10.3734 1.66666 10.8334V11.6667C1.66666 12.1267 2.03999 12.5 2.49999 12.5H5.83332C6.29332 12.5 6.66666 12.1267 6.66666 11.6667V10.8334C6.66666 10.3734 6.29332 10 5.83332 10Z",
    fill: "url(#paint1_linear_4502_27351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10V9.16671C17.5 8.70671 17.1267 8.33337 16.6667 8.33337H15C14.54 8.33337 14.1667 8.70671 14.1667 9.16671V10C13.7067 10 13.3333 10.3734 13.3333 10.8334V11.6667C13.3333 12.1267 13.7067 12.5 14.1667 12.5H17.5C17.96 12.5 18.3333 12.1267 18.3333 11.6667V10.8334C18.3333 10.3734 17.96 10 17.5 10Z",
    fill: "url(#paint2_linear_4502_27351)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4502_27351",
    x1: 10,
    y1: 8.33337,
    x2: 10,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4502_27351",
    x1: 4.16666,
    y1: 8.33337,
    x2: 4.16666,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4502_27351",
    x1: 15.8333,
    y1: 8.33337,
    x2: 15.8333,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4502_27351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortDefault);
export default __webpack_public_path__ + "static/media/port-default.972f95a9326b6c3fad10f4617175369f.svg";
export { ForwardRef as ReactComponent };